import { useNavigate, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { Button, Form } from "react-bootstrap";
import { FaSearch } from "react-icons/fa";

const SearchBox = () => {
    const navigate = useNavigate();
    const { keyword: urlKeyword } = useParams();
    const [keyword, setKeyword] = useState(urlKeyword || '');

    useEffect(() => {
        // Reset keyword if there's a URL keyword
        if (urlKeyword) {
            setKeyword('');
        }
    }, [urlKeyword]); // Run effect if urlKeyword changes
    const submitHandler = (e) => {
        e.preventDefault();
        if (keyword.trim()) {
            navigate(`/search/${encodeURIComponent(keyword)}`); // Encode keyword for URL
            setKeyword(''); // Clear the input after navigating
        } else {
            navigate('/');
        }
    };

    return (
        <Form onSubmit={submitHandler} className='d-flex ml-auto'>
            <Form.Control
                id='nav-dropdown'
                className="search-input mr-sm-5 ml-sm-5 navbar-content-sm-left"
                type='text'
                name='q'
                onChange={(e) => setKeyword(e.target.value)}
                placeholder='Search Products...'
                value={keyword}
            />
            <Button
                style={{ color: "#000000" }}
                type='submit'
                variant='outline-clear'
                className='p-2 mx-2'
                aria-label="Search"
            >
                <FaSearch aria-hidden="true" />
            </Button>
        </Form>
    );
};

export default SearchBox;